// src/hooks/programs/useProgramForm.js

import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { INITIAL_FORM_DATA } from "../../components/programs/ProgramForm/helpers/formConstants";
import { initializeFormData } from "../../components/programs/ProgramForm/helpers/formInitializer";
import { validateStep as validateFormStep } from "../../components/programs/ProgramForm/helpers/formValidator";
import { buildPayload as buildFormPayload } from "../../components/programs/ProgramForm/helpers/payloadBuilder";

/**
 * Custom hook for program form management
 */
const useProgramForm = (isEdit, currentData, isArabic) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [errors, setErrors] = useState({});

    // Initialize form data in edit mode
    useEffect(() => {
        if (isEdit && currentData) {
            const initializedData = initializeFormData(currentData);
            setFormData(initializedData);
        }
    }, [isEdit, currentData]);

    // Validate current step. Accept optional activeLang to handle multilingual fields.
    const validateStep = (step, activeLang = null) => {
        const newErrors = validateFormStep(step, formData, isEdit, isArabic, activeLang);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle next step
    const handleNext = (activeLang = null) => {
        if (!validateStep(currentStep, activeLang)) {
            toast.error(
                isArabic
                    ? "الرجاء تعبئة جميع الحقول المطلوبة بشكل صحيح"
                    : "Please fill all required fields correctly"
            );
            return false;
        }

        setCurrentStep((prev) => prev + 1);
        setErrors({});
        return true;
    };

    // Handle previous step
    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
            setErrors({});
        }
    };

    // Build payload for submission
    const buildPayload = () => {
        return buildFormPayload(formData);
    };

    return {
        currentStep,
        formData,
        setFormData,
        errors,
        setErrors,
        validateStep,
        handleNext,
        handleBack,
        buildPayload,
    };
};

export default useProgramForm;
